import { hasCharacter } from "../helpers/tools/hasCharacter";

export const priceTypeDetermine = (price) => {
  const hasRange = hasCharacter(price, "-");
  const state = {
    priceRange: hasRange ? price.split("-") : price,
    type: hasRange ? "range" : "single",
  };
  return state;
};